import { UNCATEGORIZED_POIS } from '@/config'
import { isSpecialPois } from './isSpecialPois'

export function setIconPois (poi, catalog) {
  let sub = {}

  const special = isSpecialPois(poi.properties.subcategories)
  if (special) {
    sub = UNCATEGORIZED_POIS[special]
  } else {
    catalog.some(c => {
      sub = c.subcategories.find(s => s.id === poi.properties.subcategories[0])

      return !!sub
    })
  }

  return {
    icon: sub.icon,
    iconMap: sub.iconMap
  }
}
